import React from 'react';
import {useSelector} from 'react-redux';

import {
  Modal,
  Button,
  Form,
  Col,
} from 'react-bootstrap';

import Moment from 'react-moment';
import NotificationAlert from 'react-notification-alert';
import DNS from 'components/DNS/dns.js';
import {useTranslation} from 'react-i18next';
import {translations} from '../../i18n/translations';

const ModalViewEvent = ({showModal, setShowModal, showImage, showEventname, showOrganizer, showEventStartDate, showEventStartTime, showEventEndDate, showEventEndTime, showFloors, showRooms, showUserpresent, showUsermax, showPrice, showDescription, showUserRegisterList, showUserPk, showUserNb, showEventPk, checkIfRegister, getEvent}) => {
  const token = useSelector((state) => state.token);
  const [showModalRegister, setModalRegister] = React.useState(false);
  const [showModalUnRegister, setModalUnRegister] = React.useState(false);
  const {t} = useTranslation();

  const eventUnRegister = (event) => {
    event.preventDefault();
    let tmp = [];
    const data = new FormData();
    data.append('pk', showEventPk );
    if (showUserRegisterList.length > 1) {
      showUserRegisterList.map((pkuser, key) => {
        if (pkuser.id != showUserPk) {
          tmp = tmp.concat(pkuser.id);
        }
      });
    } else {
      tmp = ['None'];
    }
    const requestOptions = {
      method: 'PATCH',
      headers: {'Authorization': 'token ' + token['tokenRedux']},
      body: data,
    };
    fetch(DNS + '/event/unregisterEvent/', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.status == 'OK') {
            checkIfRegister(showUserRegisterList, showUserPk);
            getEvent();
            notify('tc', t(translations.EVENT_MODAL_MESSAGE4));
            setModalUnRegister(false);
          } else {
            console.log('FAILED REQUEST');
            return;
          }
        });
  };

  const eventRegister = (event) => {
    event.preventDefault();
    const data = new FormData();
    data.append('pk', showEventPk );
    const requestOptions = {
      method: 'PATCH',
      headers: {'Authorization': 'token ' + token['tokenRedux']},
      body: data,
    };
    fetch(DNS + '/event/registerEvent/', requestOptions)
        .then((response) => response.json())
        .then((data) => {
          if (data.status == 'OK') {
            if (showModal) {
              setShowModal(false);
            }
            checkIfRegister(showUserRegisterList, showUserPk);
            getEvent();
            notify('tc', t(translations.EVENT_MODAL_MESSAGE3));
            setModalRegister(false);
          } else {
            console.log('FAILED REQUEST');
            return;
          }
        });
  };

  const notificationAlertRef = React.useRef(null);
  const notify = (place, notifSentence) => {
    const type = 'success';
    let options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            <p>{notifSentence}</p>
          </div>
        </div>
      ),
      type: type,
      icon: 'nc-icon nc-check-2',
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  return (
    <>
      <NotificationAlert ref={notificationAlertRef}/>
      <Modal
        className="modal modal-primary"
        show={showModalRegister}
        onHide={() => setModalRegister(false)}
        onSubmit={eventRegister}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
        </Modal.Header>
        <div className="modal-body">
          <p className="text-center">{t(translations.EVENT_MODAL_MESSAGE)}</p>
          <Form>
            <Col style={{flex: 1}}>
              <Button className="btn-fill btn-round col-sm-6" type="submit">{t(translations.EVENT_MODAL_CONFIRM)}</Button>
              <Button className="btn-fill btn-round col-sm-6" onClick={() => {
                setModalRegister(false);
              }}>{t(translations.CANCEL)}</Button>
            </Col>
          </Form>
        </div>
      </Modal>
      <Modal
        className="modal modal-primary"
        show={showModalUnRegister}
        onHide={() => setModalUnRegister(false)}
        onSubmit={eventUnRegister}
        autoFocus={false}
        enforceFocus={false}
      >
        <Modal.Header className="justify-content-center">
          <div className="modal-profile">
            <i className="nc-icon nc-notes"></i>
          </div>
        </Modal.Header>
        <div className="modal-body">
          <p className="text-center">{t(translations.EVENT_MODAL_MESSAGE1)}</p>
          <Form>
            <Col style={{flex: 1}}>
              <Button className="btn-fill btn-round col-sm-6" type="submit">{t(translations.EVENT_MODAL_CONFIRM)}</Button>
              <Button className="btn-fill btn-round col-sm-6" onClick={() => {
                setModalUnRegister(false);
              }}>{t(translations.CANCEL)}</Button>
            </Col>
          </Form>
        </div>
      </Modal>
      <Modal
        size='lg'
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showModal}
        onHide={() => setShowModal(false)}
      >
        <Modal.Header className="justify-content-center">
          <h4>{t(translations.EVENT_MODAL_FIELD)}</h4>
        </Modal.Header>
        <div className="modal-body" style={{textAlign: 'center'}}>
          <div className="row-fluid">
            <div className="span10 offset1">
              <div id="modalTab">
                <div className="tab-content">
                  <div className="tab-pane active" id="about">
                    <img id='event-img' src={showImage} border="0"/>
                    <h4 className="media-heading">{showEventname}</h4>
                    <span className="media-heading"><i className="fas fa-user"></i> {t(translations.EVENT_MODAL_FIELD1)}{showOrganizer}</span><br/>
                    <span className="media-heading"><i className="fas fa-hourglass-start"></i> {t(translations.EVENT_MODAL_FIELD2)}<Moment format="DD/MM/YYYY">{showEventStartDate}</Moment> à {showEventStartTime.substring(0, showEventStartTime.length-3)}</span><br/>
                    <span className="media-heading"><i className="fas fa-hourglass-end"></i>{t(translations.EVENT_MODAL_FIELD3)}<Moment format="DD/MM/YYYY">{showEventEndDate}</Moment> à {showEventEndTime.substring(0, showEventEndTime.length-3)}</span><br/>
                    <div style={{lineHeight: 1.5}}>
                      <span><strong>{t(translations.EVENT_MODAL_FIELD4)}</strong></span>
                      <span className="badge badge-primary">{ showFloors}</span> <span><strong>{t(translations.EVENT_MODAL_FIELD5)}</strong></span>
                      <span className="badge badge-success">{ showRooms }</span><br/>
                      <span><strong>{t(translations.EVENT_MODAL_FIELD6)}</strong></span><span className="badge badge-primary">{showUserpresent} / {showUsermax}</span>
                      <br />
                      <span>
                        <strong>{t(translations.EVENT_MODAL_FIELD7)}</strong>
                      </span>
                      { showPrice != 0 ?
                        <span className="badge badge-success">
                          {showPrice}€
                        </span> :
                        <span className="badge badge-success">
                          {t(translations.FREE)}
                        </span>
                      }
                    </div>
                    <hr></hr>
                    <p className="text-left"><strong> <i className="fas fa-edit"></i> {t(translations.EVENT_MODAL_FIELD8)} </strong>
                      {showDescription}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Modal.Footer className="modal-footer">
          { new Date(showEventEndDate.replace(/-/g, '/') + ' ' + showEventEndTime).getTime() >= new Date().getTime() ?
          <div> {
            checkIfRegister(showUserRegisterList, showUserPk) == true ?
            <Button className="btn-round btn-danger ml-3" onClick={() => {
              setShowModal(false);
              setModalUnRegister(true);
            }}>{t(translations.UNREGISTER)}</Button> : showUserpresent < showUsermax ?
            <Button onClick={() => {
              setShowModal(false);
              setModalRegister(true);
            }}>{t(translations.REGISTER)}</Button> : null
          }</div> :
          null
          }
          <p>{showUserpresent} / {showUsermax}</p>
          <br />
          <Button
            className="btn-simple"
            type="button"
            variant="link"
            onClick={() =>
              setShowModal(false)}
          >
            {t(translations.CLOSE)}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ModalViewEvent;
